export const APPLICATIONSPAGE_CMS_DATA = 'APPLICATIONSPAGE_CMS_DATA';
export const SHOW_LOADER = 'SHOW_LOADER';
